import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    name: "Mr. Rajesh Kumar",
    role: "Business Traveler",
    quote: "Meghana Cab made my trip stress-free and on time. Their punctuality and clean vehicles are impressive!",
    image: "wp-content/uploads/2021/09/testimonial-1.jpg"
  },
  {
    name: "Ms. Anjali Mehra",
    role: "Event Planner",
    quote: "I rely on Meghana Cab for all my event transportation. Drivers are polite and the service is always dependable.",
    image: "wp-content/uploads/2021/09/testimonial-2.jpg"
  },
  {
    name: "Mr. Vikram Joshi",
    role: "Corporate Client",
    quote: "Excellent customer support and very competitive pricing. I use Meghana Cab for both city and outstation trips.",
    image: "wp-content/uploads/2021/09/testimonial-3.jpg"
  },
  {
    name: "Ms. Priya Nair",
    role: "Frequent Traveler",
    quote: "I’ve booked several rides with MeghanaCab, and they never disappoint. Professional, timely, and courteous service!",
    image: "wp-content/uploads/2021/10/testimonial-4.jpg"
  }
];

export default function Testimonialsabout() {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <section
      className="testimonials-section"
      style={{ padding: '40px 0', background: '#f8f9fa', overflowX: 'hidden' }}
    >
      <div className="container" style={{ overflowX: 'hidden' }}>
        <div className="heading-block" style={{ textAlign: 'center', marginBottom: 30 }}>
          <div className="sub-title" style={{ color: '#F47C7C', fontWeight: 'bold' }}>Testimonials & Reviews</div>
          <h2 className="title">What They’re Saying</h2>
        </div>

        <Slider {...settings}>
          {testimonials.map((t, i) => (
            <div key={i} style={{ padding: 15 }}>
              <div style={{
                background: '#fff',
                padding: 20,
                borderRadius: 12,
                boxShadow: '0 4px 10px rgba(0,0,0,0.06)',
                textAlign: 'center',
                height: '100%'
              }}>
                {/* <img src={t.image} alt={t.name} style={{ borderRadius: '50%', width: 80, height: 80, objectFit: 'cover' }} /> */}
                <div style={{ color: '#FFA500', marginTop: 10 }}>
                  {[...Array(5)].map((_, i) => <i key={i} className="fas fa-star" />)}
                </div>
                <p style={{ fontStyle: 'italic', margin: '15px 0' }}>{t.quote}</p>
                <strong className='darkcolor'>{t.name}</strong><br />
                <span>{t.role}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
